import 'phaser'

export class AbstractGroupElement extends Phaser.GameObjects.Group {
  constructor(scene: Phaser.Scene, children: Phaser.GameObjects.GameObject[] | Phaser.Types.GameObjects.Group.GroupConfig | Phaser.Types.GameObjects.Group.GroupCreateConfig, config: Phaser.Types.GameObjects.Group.GroupConfig | Phaser.Types.GameObjects.Group.GroupCreateConfig) {
    super(scene, children, config);
    (this.children.entries as Phaser.GameObjects.GameObject[]).forEach((container) => this.scene.add.existing(container))
  }
}
